var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "doc-problems-icon" },
    [
      _c(
        "svg",
        {
          attrs: {
            id: `doc-problems-icon-${_vm.iconKey}`,
            width: "10",
            height: "13",
            viewBox: "0 0 10 13",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M6.96875 1H1V12H9V3.03125M6.96875 1L9 3.03125M6.96875 1V3.03125H9M3 6C3 6 5.4379 6 7 6M3 9.03125C3 9.03125 5.4379 9.03125 7 9.03125",
              stroke: "#FF238D",
              "stroke-width": "2",
            },
          }),
        ]
      ),
      _c(
        "b-popover",
        {
          attrs: {
            triggers: _vm.getPopoverType(),
            placement: "bottom",
            target: `doc-problems-icon-${_vm.iconKey}`,
          },
        },
        [_vm._v(" " + _vm._s(_vm.data.docsTrouble) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }